import gql from 'graphql-tag';

import { CartEntryFragment } from './fragments';
import { ClaimViewFields } from './fragments/claim';

export const FetchOrder = gql`
  query Order($rbiOrderId: String!) {
    Order(rbiOrderId: $rbiOrderId) {
      id: rbiOrderId
      __typename
      claim {
        ...ClaimViewFields
      }
      preorderInfo {
        endDate
        startDate
        status
        quantity
      }
      loyaltyRewards {
        id
        pointCost
        name
        sanityId
      }
      cart {
        cartEntries {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
                children {
                  ...CartEntryFragment
                  children {
                    ...CartEntryFragment
                  }
                }
              }
            }
          }
        }
        discounts {
          name
          value
        }
        donations {
          id
          name
          totalCents
        }
        feCountryCode
        payment {
          cardType
          ccLast4
          fdCorrelationId
        }
        customerName
        platform
        serviceMode
        storeAddress {
          addressLine1
          addressLine2
          city
          country
          state
        }
        storeDetails {
          timezone
        }
        storeId
        subTotalCents
        taxCents
        totalCents
        userId #  currently required for logging refund events to mParticle
        serviceMode
        deviceId
      }
      createdAt
      estimatedOrderReadyAt
      isGuestCheckoutOrder
      customer {
        id: customerId
        email
        customerId
        name
        fdCustomerId
        isoCountryCode
      }
      delivery {
        dropoff {
          beforeTime
        }
        feeCents
        feeDiscountCents
        status
        tipCents
        cancellation {
          reason
          category
        }
      }
      loyaltyTransaction {
        pointsEarned
        pointsBalance
        pointsUsed
        bonusPointsEarned
        rewardsUsed
      }
      order {
        discounts {
          discountId
          isAutomatic
          isCoupon
          name
          referenceText
          seat
          total
        }
        refund {
          adminUserEmail
          approvedAmount
          primaryReason
          refundedItems {
            name
          }
          secondaryReason
          subtotal
          tax
          transactionDateTime
        }
      }
      remediations {
        amount
        created
        displayName
        remediationReason
        remediationType
        remediationComments
        supportEmail
        transactionId
        transactionType
        userId
      }
      paymentStatus
      paymentVersion
      rbiOrderId
      refundError {
        code
        message
      }
      status
      userId
    }
  }
  ${CartEntryFragment}
  ${ClaimViewFields}
`;
